"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMeetingsUserIsBeingCreated = exports.getFetchPrimaryCalendarStatus = exports.getVerifyCalendarsStatus = exports.getCustomHostedDomainsFetchStatus = exports.getCalendarInfoFetchStatus = exports.getDisconnectMeetingsUserStatus = exports.getLinksFetchStatus = exports.getMeetingsUserSaveStatus = exports.getVerifyUserStatus = exports.getMeetingsUserCreateStatus = exports.getMeetingsUserFetchStatus = void 0;

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _actions = require("settings-ui-sdk/Meetings/actions");

var getMeetingsUserFetchStatus = (0, _getRequestStatus.default)(_actions.MeetingsActionTypes.FETCH_MEETINGS_USER);
exports.getMeetingsUserFetchStatus = getMeetingsUserFetchStatus;
var getMeetingsUserCreateStatus = (0, _getRequestStatus.default)(_actions.MeetingsActionTypes.CREATE_MEETINGS_USER);
exports.getMeetingsUserCreateStatus = getMeetingsUserCreateStatus;
var getVerifyUserStatus = (0, _getRequestStatus.default)(_actions.MeetingsActionTypes.VERIFY_USER);
exports.getVerifyUserStatus = getVerifyUserStatus;
var getMeetingsUserSaveStatus = (0, _getRequestStatus.default)(_actions.MeetingsActionTypes.SAVE_MEETINGS_USER);
exports.getMeetingsUserSaveStatus = getMeetingsUserSaveStatus;
var getLinksFetchStatus = (0, _getRequestStatus.default)(_actions.MeetingsActionTypes.FETCH_LINKS);
exports.getLinksFetchStatus = getLinksFetchStatus;
var getDisconnectMeetingsUserStatus = (0, _getRequestStatus.default)(_actions.MeetingsActionTypes.DISCONNECT_MEETINGS_USER);
exports.getDisconnectMeetingsUserStatus = getDisconnectMeetingsUserStatus;
var getCalendarInfoFetchStatus = (0, _getRequestStatus.default)(_actions.MeetingsActionTypes.FETCH_CALENDAR_INFO);
exports.getCalendarInfoFetchStatus = getCalendarInfoFetchStatus;
var getCustomHostedDomainsFetchStatus = (0, _getRequestStatus.default)(_actions.MeetingsActionTypes.FETCH_CUSTOM_HOSTED_DOMAINS);
exports.getCustomHostedDomainsFetchStatus = getCustomHostedDomainsFetchStatus;
var getVerifyCalendarsStatus = (0, _getRequestStatus.default)(_actions.MeetingsActionTypes.VERIFY_CALENDARS);
exports.getVerifyCalendarsStatus = getVerifyCalendarsStatus;
var getFetchPrimaryCalendarStatus = (0, _getRequestStatus.default)(_actions.MeetingsActionTypes.FETCH_PRIMARY_CALENDAR);
exports.getFetchPrimaryCalendarStatus = getFetchPrimaryCalendarStatus;
var getMeetingsUserIsBeingCreated = (0, _getRequestStatus.default)(_actions.MeetingsActionTypes.CREATE_MEETINGS_USER);
exports.getMeetingsUserIsBeingCreated = getMeetingsUserIsBeingCreated;